import React from 'react';
import CoverageMap from '../../../widgets/coverage/CoverageMap';

function CoveragePanel() {
  return <CoverageMap />;
}

export default CoveragePanel;
